import { useState } from "react";

import ButtonPrimary from "../buttons/ButtonPrimary/ButtonPrimary";
import InputTextArea from "../Inputs/InputTextArea/InputTextArea";
import { initialText } from "../Inputs/InputText/InputText";
import { useDiffusion } from "@/context/SDContext";
import { useImagine } from "@/context/ImagineContext";
import ButtonSecondary from "@/components/buttons/ButtonSecondary/ButtonSecondary";

interface ImagineInputProps {
  isFormValid: boolean;
  handleGenerate: () => void;
}

interface PromptProps {
  isPromptEmpty: boolean;
  setIsPromptEmpty: (value: boolean) => void;
  setPrompt: (value: any) => void;
}

const clearPrompt = (props: PromptProps) => {
  if (!props.isPromptEmpty) {
    props.setIsPromptEmpty(true);
    props.setPrompt(initialText);
  }
};

const ImagineInput = (props: ImagineInputProps) => {
  const { prompt, setPrompt } = useDiffusion();
  const { isLoading, preview } = useImagine();
  const [isPromptEmpty, setIsPromptEmpty] = useState(false);

  return (
    <div className="grid grid-cols-12 gap-2 sm:gap-4 w-full">
      <div className="col-span-12 sm:col-span-9">
        <InputTextArea
          id="textAreaImagine"
          autoFocus={true}
          text={prompt}
          disabled={!!preview}
          placeholder="Write your prompt here"
          setText={setPrompt}
          isRequired={true}
          disableGrammarly={true}
          onClick={() =>
            clearPrompt({
              isPromptEmpty,
              setIsPromptEmpty,
              setPrompt,
            })
          }
          automaticValidation={false}
          variant="colour"
        />
      </div>

      <div className="col-span-12 sm:col-span-3">
        <ButtonSecondary
          loading={isLoading && !preview}
          onClick={props.handleGenerate}
          disabled={!props.isFormValid || isLoading}
          text={"Generate (1 credit)"}
          size="lg"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default ImagineInput;
